.contrast {
  --dds-color-text-body: var(--dds-color-text-on-inverse);
  --dds-color-text-body-subtle: var(--dds-color-text-on-inverse);
  --dds-color-text-link: var(--dds-color-text-on-inverse);
  --dds-color-text-link-visited: var(
    --dds-color-text-action-visited-on-inverse
  );
  --dds-color-text-label: var(--dds-color-text-on-inverse);
  --dds-color-text-helper: var(--dds-color-text-on-inverse);
  --dds-color-text-placeholder: var(--dds-color-text-on-inverse);
  --dds-color-icon-link: var(--dds-color-text-on-inverse);
  --dds-color-text-default-inversable: var(--dds-color-text-on-inverse);
  --dds-color-text-subtle-inversable: var(--dds-color-text-on-inverse);
  --dds-color-text-medium-inversable: var(--dds-color-text-on-inverse);
  --dds-color-text-action-resting-inversable: var(--dds-color-text-on-inverse);
  --dds-color-text-action-hover-inversable: var(--dds-color-text-on-inverse);
  --dds-color-text-requiredfield-inversable: var(--dds-color-text-on-inverse);
  color: var(--dds-color-text-on-inverse);
  --dds-color-icon-default-inversable: var(--dds-color-text-on-inverse);
  --dds-color-icon-subtle-inversable: var(--dds-color-text-on-inverse);
  --dds-color-icon-medium-inversable: var(--dds-color-text-on-inverse);
  --dds-color-icon-action-resting-inversable: var(--dds-color-icon-on-inverse);
  --dds-color-icon-action-hover-inversable: var(--dds-color-icon-on-inverse);
}

.tertiary-medium {
  --dds-color-text-body: var(--dds-color-text-on-tertiary-medium);
  --dds-color-text-body-subtle: var(--dds-color-text-on-tertiary-medium);
  --dds-color-text-link: var(--dds-color-text-on-tertiary-medium);
  --dds-color-text-link-visited: var(
    --dds-color-text-action-visited-on-te--dds-color-text-on-tertiary-medium
  );
  --dds-color-text-label: var(--dds-color-text-on-tertiary-medium);
  --dds-color-text-helper: var(--dds-color-text-on-tertiary-medium);
  --dds-color-text-placeholder: var(--dds-color-text-on-tertiary-medium);
  --dds-color-icon-link: var(--dds-color-text-on-tertiary-medium);
  --dds-color-text-default-inversable: var(--dds-color-text-on-tertiary-medium);
  --dds-color-text-subtle-inversable: var(--dds-color-text-on-tertiary-medium);
  --dds-color-text-medium-inversable: var(--dds-color-text-on-tertiary-medium);
  --dds-color-text-action-resting-inversable: var(
    --dds-color-text-on-tertiary-medium
  );
  --dds-color-text-action-hover-inversable: var(
    --dds-color-text-on-tertiary-medium
  );
  --dds-color-text-requiredfield-inversable: var(
    --dds-color-text-on-tertiary-medium
  );
  color: var(--dds-color-text-on-tertiary-medium);
  --dds-color-icon-default-inversable: var(--dds-color-text-on-tertiary-medium);
  --dds-color-icon-subtle-inversable: var(--dds-color-text-on-tertiary-medium);
  --dds-color-icon-medium-inversable: var(--dds-color-text-on-tertiary-medium);
  --dds-color-icon-action-resting-inversable: var(
    --dds-color-icon-on-te--dds-color-text-on-tertiary-medium
  );
  --dds-color-icon-action-hover-inversable: var(
    --dds-color-icon-on-te--dds-color-text-on-tertiary-medium
  );
}

:where(.a),
:where(.a--nested__parent .a--nested__child) {
  font: inherit;
  color: var(--dds-color-text-link);
  width: fit-content;
  text-decoration: underline;
  text-decoration-thickness: max(1px, 0.0625rem);
  text-underline-offset: max(4px, 0.25rem);
  margin: 0;

  &:hover {
    text-decoration-color: transparent;
  }

  @media (prefers-reduced-motion: no-preference) {
    transition:
      color var(--dds-motion-micro-state),
      text-decoration-color var(--dds-motion-micro-state),
      var(--dds-focus-transition);
  }
}

:where(.a--margins) {
  display: block;
  margin-top: 0;
  margin-bottom: var(--dds-font-body-long-medium-paragraph-spacing);
}

:where(.a--with-icon) > svg {
  display: inline;
  margin: 0.1em 0.1em -0.1em;
  transform: translateY(0.05em);
  vertical-align: baseline;
}

.a--visited:visited {
  color: var(--dds-color-text-link-visited);
}

:where(.body-short-xsmall) {
  margin: 0;
  font: var(--dds-font-body-short-xsmall);
  letter-spacing: var(--dds-font-body-short-xsmall-letter-spacing);
  color: var(--dds-color-text-body);
}

:where(.body-short-xsmall--margins) {
  display: block;
  margin-top: 0;
  margin-bottom: var(--dds-font-body-short-xsmall-paragraph-spacing);
}

:where(.body-short-small) {
  margin: 0;
  font: var(--dds-font-body-short-small);
  letter-spacing: var(--dds-font-body-short-small-letter-spacing);
  color: var(--dds-color-text-body);
}

:where(.body-short-small--margins) {
  display: block;
  margin-top: 0;
  margin-bottom: var(--dds-font-body-short-small-paragraph-spacing);
}

:where(.body-short-medium) {
  margin: 0;
  font: var(--dds-font-body-short-medium);
  letter-spacing: var(--dds-font-body-short-medium-letter-spacing);
  color: var(--dds-color-text-body);
}

:where(.body-short-medium--margins) {
  display: block;
  margin-top: 0;
  margin-bottom: var(--dds-font-body-short-medium-paragraph-spacing);
}

:where(.body-short-large) {
  margin: 0;
  font: var(--dds-font-body-short-large);
  letter-spacing: var(--dds-font-body-short-large-letter-spacing);
  color: var(--dds-color-text-body);
}

:where(.body-short-large--margins) {
  display: block;
  margin-top: 0;
  margin-bottom: var(--dds-font-body-short-large-paragraph-spacing);
}

:where(.body-long-xsmall) {
  margin: 0;
  font: var(--dds-font-body-long-xsmall);
  letter-spacing: var(--dds-font-body-long-xsmall-letter-spacing);
  color: var(--dds-color-text-body);
}

:where(.body-long-xsmall--margins) {
  display: block;
  margin-top: 0;
  margin-bottom: var(--dds-font-body-long-xsmall-paragraph-spacing);
}

:where(.body-long-small) {
  margin: 0;
  font: var(--dds-font-body-long-small);
  letter-spacing: var(--dds-font-body-long-small-letter-spacing);
  color: var(--dds-color-text-body);
}

:where(.body-long-small--margins) {
  display: block;
  margin-top: 0;
  margin-bottom: var(--dds-font-body-long-small-paragraph-spacing);
}

:where(.body-long-medium) {
  margin: 0;
  font: var(--dds-font-body-long-medium);
  letter-spacing: var(--dds-font-body-long-medium-letter-spacing);
  color: var(--dds-color-text-body);
}

:where(.body-long-medium--margins) {
  display: block;
  margin-top: 0;
  margin-bottom: var(--dds-font-body-long-medium-paragraph-spacing);
}

:where(.body-long-large) {
  margin: 0;
  font: var(--dds-font-body-long-large);
  letter-spacing: var(--dds-font-body-long-large-letter-spacing);
  color: var(--dds-color-text-body);
}

:where(.body-long-large--margins) {
  display: block;
  margin-top: 0;
  margin-bottom: var(--dds-font-body-long-large-paragraph-spacing);
}

:where(.lead-medium) {
  margin: 0;
  font: var(--dds-font-lead-medium);
  letter-spacing: var(--dds-font-lead-medium-letter-spacing);
  color: var(--dds-color-text-body);
}

:where(.lead-medium--margins) {
  display: block;
  margin-top: 0;
  margin-bottom: var(--dds-font-lead-medium-paragraph-spacing);
}

:where(.heading-xxsmall) {
  margin: 0;
  font: var(--dds-font-heading-xxsmall);
  letter-spacing: var(--dds-font-heading-xxsmall-letter-spacing);
  color: var(--dds-color-text-body);
}

:where(.heading-xxsmall--margins) {
  display: block;
  margin-top: 0;
  margin-bottom: var(--dds-font-heading-xxsmall-paragraph-spacing);
  padding-top: var(--dds-spacing-padding-top-heading);
}

:where(.heading-xsmall) {
  margin: 0;
  font: var(--dds-font-heading-xsmall);
  letter-spacing: var(--dds-font-heading-xsmall-letter-spacing);
  color: var(--dds-color-text-body);
}

:where(.heading-xsmall--margins) {
  display: block;
  margin-top: 0;
  margin-bottom: var(--dds-font-heading-xsmall-paragraph-spacing);
  padding-top: var(--dds-spacing-padding-top-heading);
}

:where(.heading-small) {
  margin: 0;
  font: var(--dds-font-heading-small);
  letter-spacing: var(--dds-font-heading-small-letter-spacing);
  color: var(--dds-color-text-body);
}

:where(.heading-small--margins) {
  display: block;
  margin-top: 0;
  margin-bottom: var(--dds-font-heading-small-paragraph-spacing);
  padding-top: var(--dds-spacing-padding-top-heading);
}

:where(.heading-medium) {
  margin: 0;
  font: var(--dds-font-heading-medium);
  letter-spacing: var(--dds-font-heading-medium-letter-spacing);
  color: var(--dds-color-text-body);
}

:where(.heading-medium--margins) {
  display: block;
  margin-top: 0;
  margin-bottom: var(--dds-font-heading-medium-paragraph-spacing);
  padding-top: var(--dds-spacing-padding-top-heading);
}

:where(.heading-large) {
  margin: 0;
  font: var(--dds-font-heading-large);
  letter-spacing: var(--dds-font-heading-large-letter-spacing);
  color: var(--dds-color-text-body);
}

:where(.heading-large--margins) {
  display: block;
  margin-top: 0;
  margin-bottom: var(--dds-font-heading-large-paragraph-spacing);
  padding-top: var(--dds-spacing-padding-top-heading);
}

:where(.heading-xlarge) {
  margin: 0;
  font: var(--dds-font-heading-xlarge);
  letter-spacing: var(--dds-font-heading-xlarge-letter-spacing);
  color: var(--dds-color-text-body);
}

:where(.heading-xlarge--margins) {
  display: block;
  margin-top: 0;
  margin-bottom: var(--dds-font-heading-xlarge-paragraph-spacing);
  padding-top: var(--dds-spacing-padding-top-heading);
}

:where(.heading-xxlarge) {
  margin: 0;
  font: var(--dds-font-heading-xxlarge);
  letter-spacing: var(--dds-font-heading-xxlarge-letter-spacing);
  color: var(--dds-color-text-body);
}

:where(.heading-xxlarge--margins) {
  display: block;
  margin-top: 0;
  margin-bottom: var(--dds-font-heading-xxlarge-paragraph-spacing);
  padding-top: var(--dds-spacing-padding-top-heading);
}

:where(.heading--margins-over-input) {
  margin-bottom: var(--dds-spacing-x1-5);
}

:where(.label-medium) {
  margin: 0;
  font: var(--dds-font-label-medium);
  letter-spacing: var(--dds-font-label-medium-letter-spacing);
  color: var(--dds-color-text-label);
}

:where(.label-medium--margins) {
  display: block;
  margin-bottom: var(--dds-spacing-x0-125);
}

:where(.legend) {
  padding-inline: 0;
}

:where(.legend--margins-over-input) {
  margin-bottom: var(--dds-spacing-x1-5);
}

:where(.caption) {
  text-align: left;
}

:where(.caption--withMargins) {
  display: table-caption;
}

:where(.bold) {
  font-weight: 600;
}

:where(.italic) {
  font-style: italic;
}

:where(.underline) {
  text-decoration: underline;
}

.text-color--inherit {
  color: inherit;
}

.text-color--default {
  color: var(--dds-color-text-default-inversable);
}

.text-color--medium {
  color: var(--dds-color-text-medium-inversable);
}

.text-color--subtle {
  color: var(--dds-color-text-subtle-inversable);
}

.text-color--requiredfield {
  color: var(--dds-color-text-requiredfield-inversable);
}

.text-color--action-resting {
  color: var(--dds-color-text-action-resting-inversable);
}

.text-color--action-hover:hover {
  color: var(--dds-color-text-action-hover-inversable);
}

.text-color--action-visited:visited {
  color: var(--dds-color-text-link-visited);
}

.text-color--on-action {
  color: var(--dds-color-text-on-action);
}

.text-color--on-status-default {
  color: var(--dds-color-text-on-status-default);
}

.text-color--on-status-strong {
  color: var(--dds-color-text-on-status-strong);
}

.text-color--on-notification {
  color: var(--dds-color-text-on-notification);
}

.text-color--on-primary-default {
  color: var(--dds-color-text-on-primary-default);
}

.text-color--on-primary-medium {
  color: var(--dds-color-text-on-primary-medium);
}

.text-color--on-primary-subtle {
  color: var(--dds-color-text-on-primary-subtle);
}

.text-color--on-primary-strong {
  color: var(--dds-color-text-on-primary-strong);
}

.text-color--on-secondary-default {
  color: var(--dds-color-text-on-secondary-default);
}

.text-color--on-secondary-medium {
  color: var(--dds-color-text-on-secondary-medium);
}

.text-color--on-secondary-subtle {
  color: var(--dds-color-text-on-secondary-subtle);
}

.text-color--on-secondary-strong {
  color: var(--dds-color-text-on-secondary-strong);
}

.text-color--on-tertiary-default {
  color: var(--dds-color-text-on-tertiary-default);
}

.text-color--on-tertiary-medium {
  color: var(--dds-color-text-on-tertiary-medium);
}

.text-color--on-tertiary-subtle {
  color: var(--dds-color-text-on-tertiary-subtle);
}

.text-color--on-tertiary-strong {
  color: var(--dds-color-text-on-tertiary-strong);
}

.text-color--on-data-default {
  color: var(--dds-color-text-on-data-default);
}

.text-color--on-data-subtle {
  color: var(--dds-color-text-on-data-subtle);
}

.text-color--on-inverse {
  color: var(--dds-color-text-on-inverse);
}

.icon-color--default {
  color: var(--dds-color-icon-default-inversable);
}

.icon-color--medium {
  color: var(--dds-color-icon-medium-inversable);
}

.icon-color--subtle {
  color: var(--dds-color-icon-subtle-inversable);
}

.icon-color--on-action {
  color: var(--dds-color-icon-on-action);
}

.icon-color--action-resting {
  color: var(--dds-color-icon-action-resting-inversable);
}

.icon-color--action-hover:hover {
  color: var(--dds-color-icon-action-hover-inversable);
}

.icon-color--on-action {
  color: var(--dds-color-icon-on-action);
}

.icon-color--on-info-default {
  color: var(--dds-color-icon-on-info-default);
}

.icon-color--on-info-strong {
  color: var(--dds-color-icon-on-info-strong);
}

.icon-color--on-success-default {
  color: var(--dds-color-icon-on-success-default);
}

.icon-color--on-success-strong {
  color: var(--dds-color-icon-on-success-strong);
}

.icon-color--on-danger-default {
  color: var(--dds-color-icon-on-danger-default);
}

.icon-color--on-danger-strong {
  color: var(--dds-color-icon-on-danger-strong);
}

.icon-color--on-warning-default {
  color: var(--dds-color-icon-on-warning-default);
}

.icon-color--on-warning-strong {
  color: var(--dds-color-icon-on-warning-strong);
}

.icon-color--on-inverse {
  color: var(--dds-color-icon-on-inverse);
}
